import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { GET_USER_FAILURE, getUser, getUserGroups, getUserPatientInfo } from './users.actions';
import { handleToastMessage, setPageTitle } from '../layout/layout.actions';
import UserDetails from './userDetails.component';

class UserViewContainer extends Component {
  async componentDidMount() {
    const { id } = this.props.match.params;
    const response = await this.props.getUser(id);

    if (response.type === GET_USER_FAILURE) {
      this.props.handleToastMessage('Could not find that user.', true);
      this.props.history.push('/users');
      return;
    }

    const user = response.response;
    this.props.setPageTitle(`${user.firstName} ${user.lastName}`);
    this.props.getUserGroups(id);
    if (user) {
      await Promise.all([
        this.props.getUserGroups(id),
        user.simplifedPatientId && this.props.getUserPatientInfo(user.simplifedPatientId),
      ]);
    }
  }

  render() {
    const { isLoading, selectedUser } = this.props;

    if (isLoading || !selectedUser) {
      return <div className="loader" />;
    }

    return <UserDetails user={selectedUser} />;
  }
}

UserViewContainer.propTypes = {
  selectedUser: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  errors: PropTypes.array.isRequired,

  getUser: PropTypes.func.isRequired,
  getUserGroups: PropTypes.func.isRequired,
  getUserPatientInfo: PropTypes.func.isRequired,
  handleToastMessage: PropTypes.func.isRequired,
  setPageTitle: PropTypes.func.isRequired,

  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  selectedUser: state.users.get('selectedUser'),
  isLoading: state.users.get('isLoading'),
  errors: state.users.get('errors'),
});

const prepareForExport = compose(
  withRouter,
  connect(mapStateToProps, {
    getUser,
    getUserGroups,
    getUserPatientInfo,
    handleToastMessage,
    setPageTitle,
  }),
);

export default prepareForExport(UserViewContainer);
